"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * A container styled as a card.
         */
        var Card = /** @class */ (function (_super) {
            __extends(Card, _super);
            function Card() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Card.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                this._hasActions = $dyn.observable(false);
                this._hasNotes = $dyn.observable(false);
                this._hasImage = $dyn.observable(false);
                this._hasSymbol = $dyn.observable(false);
                this._hasCaption = $dyn.observable(false);
                this._hasFooter = $dyn.observable(false);
                this._hasHeading = $dyn.observable(false);
                this.image = $dyn.observable(false);
                this.childrenChanged = true;
                if ($(element).find(".image")[0]) {
                    $(element).addClass("cardOptionalImage");
                }
                if ($(element).find(".businessCard_notes")[0]) {
                    $(element).addClass("cardOptionalNotes");
                }
                $dyn.observe(this.Children, function () {
                    _this.childrenChanged = true;
                });
                this.HasImage = $dyn.computed(function () {
                    _this.EvaluateChildren();
                    return _this._hasImage();
                });
                this.HasHeading = $dyn.computed(function () {
                    _this.EvaluateChildren();
                    return _this._hasHeading();
                });
                this.HasCaption = $dyn.computed(function () {
                    _this.EvaluateChildren();
                    return _this._hasCaption();
                });
                this.HasSymbol = $dyn.computed(function () {
                    _this.EvaluateChildren();
                    return _this._hasSymbol();
                });
                $dyn.observe(this._hasImage, function (value) {
                    var $listItem = $($(element).parents(".listItem")[0]);
                    if ($listItem) {
                        if (value) {
                            if ($(element).hasClass("ThumbnailCard")) {
                                $listItem.addClass("listItemThumbnailCard");
                                $listItem.removeClass("listItemImageCard");
                            }
                            else {
                                $listItem.addClass("listItemImageCard");
                                $listItem.removeClass("listItemThumbnailCard");
                            }
                            $listItem.removeClass("listItemCard");
                        }
                        else {
                            $listItem.addClass("listItemCard");
                            $listItem.removeClass("listItemImageCard");
                            $listItem.removeClass("listItemThumbnailCard");
                        }
                    }
                });
                this.HasFooter = $dyn.computed(function () {
                    _this.EvaluateChildren();
                    return _this._hasFooter();
                });
                this.HasActions = $dyn.computed(function () {
                    _this.EvaluateChildren();
                    return _this._hasActions();
                });
                this.HasNotes = $dyn.computed(function () {
                    _this.EvaluateChildren();
                    return _this._hasNotes();
                });
            };
            Card.prototype.EvaluateChildren = function () {
                var e_1, _a;
                if (!this.childrenChanged) {
                    return;
                }
                this.childrenChanged = false;
                this._hasImage(false);
                this._hasSymbol(false);
                this._hasCaption(false);
                this._hasFooter(false);
                this._hasActions(false);
                this._hasNotes(false);
                this._hasHeading(false);
                var children = $dyn.value(this.Children);
                if (children) {
                    try {
                        for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
                            var child = children_1_1.value;
                            // Cards should skip focus for Image only - otherwise no
                            if (child.TypeName === "Image" || child.TypeName === "ImageCell") {
                                if ($dyn.isObservable(child.Skip)) {
                                    child.Skip(true);
                                }
                                else {
                                    child.Skip = true;
                                }
                            }
                            if ($dyn.util.isEnhancedTabSequenceEnabled()) {
                                if ($dyn.isObservable(child.Skip)) {
                                    child.Skip(false);
                                }
                                else {
                                    child.Skip = false;
                                }
                            }
                            if (child.TypeName === "Image" || child.TypeName === "ImageCell") {
                                this._hasImage(true);
                                if ($(child.element).find(".imageBinder-image").length === 0) {
                                    this._hasSymbol(true);
                                }
                            }
                            if ($(child.element).hasClass("ImageCaption")) {
                                this._hasCaption(true);
                            }
                            if ($(child.element).hasClass("Heading")) {
                                this._hasHeading(true);
                            }
                            if ($(child.element).hasClass("Footer1") || $(child.element).hasClass("Footer2")) {
                                this._hasFooter(true);
                            }
                            if ($(child.element).hasClass("toolbar")) {
                                this._hasActions(true);
                            }
                            if ($(child.element).hasClass("businessCard_notes")) {
                                this._hasNotes(true);
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
            };
            return Card;
        }($dyn.ui.Container));
        controls.Card = Card;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Card.js.map
